"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToDate = void 0;
function stringToDate(monthYear) {
    if (typeof monthYear !== 'string') {
        return undefined;
    }
    const [month, year] = monthYear.split('/').map(Number);
    if (!month || !year || month < 1 || month > 12) {
        throw new Error('Invalid month/year format. Expected format: MM/YY');
    }
    const fullYear = year + 2000;
    const monthIndexCorrected = month - 1; // Months are zero-based in JavaScript
    return new Date(fullYear, monthIndexCorrected, 1);
}
exports.stringToDate = stringToDate;
